import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },

  // {
  //   path: '/about',
  //   name: 'About',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  {
    path: '/page2',
    name: 'Page2',
    // component: Page2
    component: () => import(/* webpackChunkName: "page2" */ '../views/Page2.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../components/Login.vue')
  },
  {
    path: '/registro',
    name: 'Registro',
    component: () => import(/* webpackChunkName: "about" */ '../components/Registro.vue')
  },
  {
    path: '/olvidoPass',
    name: 'olvidoPass',
    component: () => import(/* webpackChunkName: "about" */ '../components/olvidoPass.vue')
  },
  {
    path: '/bienvenida',
    name: 'Bienvenida',
    component: () => import(/* webpackChunkName: "about" */ '../views/Bienvenida.vue')
  },
  {
    path: '/gestionUsuarios',
    name: 'GestionUsuarios',
    component: () => import(/* webpackChunkName: "about" */ '../views/GestionUsuarios.vue')
  },
  {
    path: '/gestionCatastro',
    name: 'GestionCatastro',
    component: () => import(/* webpackChunkName: "about" */ '../views/GestionCatastro.vue')
  },
  {
    path: '/gestionDicc',
    name: 'GestionDicc',
    component: () => import(/* webpackChunkName: "about" */ '../views/GestionDicc.vue')
  },
  {
    path: '/utilidadesMiembros',
    name: 'UtilidadesMiembros',
    component: () => import(/* webpackChunkName: "about" */ '../views/UtilidadesMiembros.vue')
  },
  {
    path: '/busquedas',
    name: 'Busquedas',
    component: () => import(/* webpackChunkName: "about" */ '../views/Busquedas.vue')
  },
  {
    path: '/datosPersonales',
    name: 'datosPersonales',
    component: () => import(/* webpackChunkName: "about" */ '../views/datosPersonales.vue')
  },
  {
    path: '/datosCatalogo',
    name: 'datosCatalogo',
    component: () => import(/* webpackChunkName: "about" */ '../views/datosCatalogo.vue')
  },
  {
    path: '/menuColecciones',
    name: 'MenuColecciones',
    component: () => import(/* webpackChunkName: "about" */ '../views/MenuColecciones.vue')
  },
  {
    path: '/gesLibros',
    name: 'GesLibros',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesLibros.vue')
  },
  {
    path: '/gesMemorias',
    name: 'GesMemorias',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesMemorias.vue')
  },
  {
    path: '/gesTesisY',
    name: 'GesTesisY',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesTesisY.vue')
  },
  {
    path: '/gesPubPer',
    name: 'GesPubPer',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesPubPer.vue')
  },
  {
    path: '/gesHemero',
    name: 'GesHemero',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesHemero.vue')
  },
  {
    path: '/gesSeparatas',
    name: 'GesSeparatas',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesSeparatas.vue')
  },
  {
    path: '/gesSellos',
    name: 'GesSellos',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesSellos.vue')
  },
  {
    path: '/gesPostales',
    name: 'GesPostales',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesPostales.vue')
  },
  {
    path: '/gesMiscel',
    name: 'GesMiscel',
    component: () => import(/* webpackChunkName: "about" */ '../views/GesMiscel.vue')
  },
  {
    path: '/vistaCol',
    name: 'VistaCol',
    component: () => import(/* webpackChunkName: "about" */ '../views/VistaCol.vue'),
    props: true
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
